import { render, staticRenderFns } from "./Champion.vue?vue&type=template&id=db7a1a24&"
import script from "./Champion.vue?vue&type=script&lang=js&"
export * from "./Champion.vue?vue&type=script&lang=js&"
import style0 from "./Champion.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports